<template>
	<Modal maxWidth="max-w-3xl" :active="showCartValidationModal" @hide="$emit('update:showCartValidationModal', false)" :hideX="true">
		<div class="p-2 sm:p-4 text-ihh-midnight-gray">
			<!-- Header with icon -->
			<div class="flex flex-col items-center mb-6">
				<div class="bg-ihh-dark-salmon/10 p-3 rounded-full mb-4">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-ihh-dark-salmon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
					</svg>
				</div>
				<h2 class="text-ihh-midnight-gray font-semibold text-xl sm:text-2xl">Cart Updated</h2>
				<p class="text-base sm:text-lg text-ihh-midnight-gray/80 text-center mt-2 max-w-md">Your cart has been updated due to inventory changes.</p>
			</div>

			<!-- Content container with shadow -->
			<div class="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden mb-6">
				<!-- Out of stock items section -->
				<div v-if="oosItems.length > 0" class="p-4 sm:p-5 border-b border-gray-100">
					<h3 class="font-semibold text-lg flex items-center mb-3 text-red-600">
						<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
						</svg>
						Items removed (out of stock)
					</h3>
					<ul class="space-y-3">
						<li v-for="item in oosItems" :key="item.item?.id || item.variant?.id" class="flex items-start pl-2 border-l-2 border-red-500">
							<div class="ml-2">
								<span class="font-medium">{{ item.item?.name || 'Unknown item' }}</span>
								<span class="ml-2 text-sm text-ihh-midnight-gray/70">(Qty: {{ item.quantity }})</span>
							</div>
						</li>
					</ul>
				</div>

				<!-- Low stock items section -->
				<div v-if="lowStockItems.length > 0" class="p-4 sm:p-5">
					<h3 class="font-semibold text-lg flex items-center mb-3 text-amber-600">
						<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
							/>
						</svg>
						Items with adjusted quantities
					</h3>
					<ul class="space-y-3">
						<li v-for="item in lowStockItems" :key="item.item?.id || item.variant?.id" class="flex items-start pl-2 border-l-2 border-amber-300">
							<div class="ml-2 w-full">
								<span class="font-medium">{{ item.item?.name || 'Unknown item' }}</span>
								<div class="flex items-center justify-between mt-1 text-sm bg-amber-50 rounded-md p-2 w-full sm:w-auto">
									<span class="text-ihh-midnight-gray/80"
										>Requested: <span class="font-medium">{{ item.originalQty }}</span></span
									>
									<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mx-2 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
									</svg>
									<span class="text-ihh-midnight-gray/80"
										>Available: <span class="font-medium">{{ item.quantity }}</span></span
									>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>

			<!-- Button -->
			<div class="flex w-full justify-center pt-2">
				<button
					@click="handleClose"
					class="bg-ihh-dark-salmon hover:bg-ihh-salmon text-white py-3 px-8 rounded-md font-medium transition-colors shadow-sm hover:shadow flex items-center justify-center w-full sm:w-auto min-w-[200px]"
				>
					Continue
					<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
					</svg>
				</button>
			</div>
		</div>
	</Modal>
</template>

<script>
export default {
	name: 'CartValidation',
	props: ['showCartValidationModal', 'oosItems', 'lowStockItems'],
	data() {
		return {}
	},
	methods: {
		handleClose() {
			this.$emit('update:showCartValidationModal', false)
		},
	},
}
</script>

<style scoped></style>
